<!-- @catalog Option row for a CInputSelect #option slot: pass the slot's itemProps via :item-props (keeps QSelect keyboard/click wiring). Default slot is the label line; #caption adds a second line; #avatar a leading section. Style all dropdown option rows here. -->
<template>
  <q-item class="c-select-option tw-rounded" v-bind="itemProps">
    <q-item-section v-if="$slots.avatar" avatar>
      <slot name="avatar" />
    </q-item-section>

    <q-item-section>
      <q-item-label class="c-select-option__label">
        <slot />
      </q-item-label>

      <q-item-label
        v-if="$slots.caption"
        caption
        class="c-select-option__caption"
      >
        <slot name="caption" />
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script setup lang="ts">
defineProps<{
  itemProps: Record<string, unknown>;
}>();
</script>
